// #region Import Used Components and Services
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CommonFunctions {
  PrintDocuments(divName, Header, LoanNo) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${Header} - ${LoanNo}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>

          body{
          width:100% !important;
          }
          table {
            width: 100% !important;
          }
          thead th, thead td {
            border-bottom-width: 1px;
           
          }


          
          th{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          td{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          body{
            width:1060px
          }
          .bg-success1 {
            background: var(--theme-primary) !important;
            font-weight: 500;
            color: #000;
            font-size: 12px;
          }
          .form-control1 {
            display: block;
            width: 100%;
            height: calc(1.0em + 0.75rem + 2px);
            padding: 0.120rem 0.3rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #000;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #888;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          }
          .table th, .table td {
            padding: 0.25rem 0.25rem 0 0.25rem !important;
            vertical-align: middle;
          }
     

          @media print {
            // @page {
              
            //     size: A4;
            //     margin: 10px 20px 20px 20px; 
            //     content: counter(page) "/" counter(pages);

         
             
              
            // }
            #foot {
              content: counter(page) "/" counter(pages);
              counter-increment: page;
            }
            .mt-2 {
              margin-top: 0.5rem !important;
            }
          
         
          .sign_hr {
            margin-top: 2rem;
            margin-bottom: 1rem;
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 1);
          }

        //  .annexB{
        //   margin-bottom: 20rem;
        //  }
          
         
          </style>
        </head>
        <body onload="window.print(); window.close()">${printContents}
        <footer></footer>
        </body>
      </html>`);
    popupWin.document.close();
  }

  PrintFDRDeposit(divName, Header, Deposit_No) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${Header} - ${Deposit_No}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>
          thead th, thead td {
            border-bottom-width: 1px;
          }
          
          th{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          td{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          body{
            width:1060px
          }
          .bg-success1 {
            background: var(--theme-primary) !important;
            font-weight: 500;
            color: #000;
            font-size: 12px;
          }
          .form-control1 {
            display: block;
            width: 100%;
            height: calc(1.0em + 0.75rem + 2px);
            padding: 0.120rem 0.3rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #000;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #888;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          }
          .table th, .table td {
            padding: 0.25rem 0.25rem 0 0.25rem !important;
            vertical-align: middle;
          }
          @media print {
            @page {
              size: A4;
              margin: 10px 20px 20px 20px; 
              content: counter(page) "/" counter(pages);
            }
            .mt-2 {
              margin-top: 0.5rem !important;
            }

            #abc::before{
              counter-increment: fot;
            content: counter('fot') "Section";
            }
          }
          .sign_hr {
            margin-top: 2rem;
            margin-bottom: 1rem;
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 1);
          }
          </style>
        </head>
        <body onload="window.print(); window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  PrintBalanceSheet(divName, Header, LoanNo) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${Header} - ${LoanNo}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>
          thead th, thead td {
            border-bottom-width: 1px;
          }
          
          th{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          td{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          body{
            width:1060px
          }
          .bg-success1 {
            background: var(--theme-primary) !important;
            font-weight: 500;
            color: #000;
            font-size: 12px;
          }
          .form-control1 {
            display: block;
            width: 100%;
            height: calc(1.0em + 0.75rem + 2px);
            padding: 0.120rem 0.3rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #000;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #888;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          }
          .table th, .table td {
            padding: 0.25rem 0.25rem 0 0.25rem !important;
            vertical-align: middle;
          }
          @media print {
            body {
              margin: 40px 0 40px 0;
              height: auto;
            }
            @page {
              size: A4;
              margin: 30px 20px 40px 20px; 
              content: counter(page) "/" counter(pages);
            }
            .mt-2 {
              margin-top: 0.5rem !important;
            }
            .mt-5 {
              margin-top: 2.5rem !important;
            }
            .header{
              position: fixed;
              top: 20px;
              bottom: 40px;
            }
          }

            .page-header, .page-header-space {
                height: 100px;
              }

              .page-footer, .page-footer-space {
                height: 20px;

              }

              .page-footer {
                position: fixed;
                bottom: 0;
                width: 100%;
               
                
              }

              .page-header {
                position: fixed;
                top: 0mm;
                width: 100%;
                
              }

              .page {
                page-break-after: always;
              }

              //@page {
              //  margin: 20mm
              //}

              //@media print {
              //   thead {display: table-header-group;} 
              //   tfoot {display: table-footer-group;}
   
              //   button {display: none;}
   
              //   body {margin: 0;}
              //}
          .sign_hr {
            margin-top: 2rem;
            margin-bottom: 1rem;
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 1);
          }
          </style>
        </head>
        <body onload="window.print(); window.close()">


<div >
${printContents}
</div>
</body>
      </html>`);
    popupWin.document.close();
  }

  PrintTrailDocuments(divName, Header, LoanNo) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${Header} - ${LoanNo}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>
          thead th, thead td {
            border-bottom-width: 1px;
           
          }
          
          th{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          td{
            font-size: 14px;
            padding: 0.20rem !important;
            vertical-align: top;
            border: 1px solid #333;
          }
          body{
            width:1060px
          }
          .bg-success1 {
            background: var(--theme-primary) !important;
            font-weight: 500;
            color: #000;
            font-size: 12px;
          }
          .form-control1 {
            display: block;
            width: 100%;
            height: calc(1.0em + 0.75rem + 2px);
            padding: 0.120rem 0.3rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #000;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #888;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          }
          .table th, .table td {
            padding: 0.25rem 0.25rem 0 0.25rem !important;
            vertical-align: middle;
          }
     

          @media print {
            // @page {
              
            //     size: A4;
            //     margin: 10px 20px 20px 20px; 
            //     content: counter(page) "/" counter(pages);

         
             
              
            // }
            #foot {
              content: counter(page) "/" counter(pages);
              counter-increment: page;
            }
            .mt-2 {
              margin-top: 0.5rem !important;
            }
          
         
          .sign_hr {
            margin-top: 2rem;
            margin-bottom: 1rem;
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 1);
          }
          .mat-icon-button{
            border: none;
            background-color: #fff;
          }
          //.cdk-column-Group_Name{
          //  font-weight:bold;
          //}
         
          </style>
        </head>
        <body onload="window.print(); window.close()">${printContents}
        <footer></footer>
        </body>
      </html>`);
    popupWin.document.close();
  }

  PrintCibil(divName, Header, LoanNo) {
    let printContents, popupWin;
    const printElem = document.getElementById(divName);
    if (!printElem) {
      window.print();
      return;
    }
    printContents = printElem.innerHTML;
    popupWin = window.open("", "_blank", "width=1200,height=900");
    if (!popupWin) {
      window.print();
      return;
    }

    let stylesHtml = "";
    document
      .querySelectorAll("style, link[rel='stylesheet']")
      .forEach((node) => {
        stylesHtml += node.outerHTML;
      });

    popupWin.document.open();
    popupWin.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${Header} - ${LoanNo}</title>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          ${stylesHtml}
          <style>
            @page {
              size: A4 portrait;
              margin: 8mm 8mm 8mm 8mm;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            body {
              background: #ffffff !important;
              color: #0f172a !important;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            .no-print {
              display: none !important;
            }
            .cibil-wrapper {
              padding: 0 !important;
              background: #ffffff !important;
            }
            .cibil-report-container {
              border: none !important;
              box-shadow: none !important;
              max-width: 100% !important;
              width: 100% !important;
            }
            .cir-header-card {
              background: linear-gradient(135deg, #0b2239 0%, #004b63 100%) !important;
              color: #ffffff !important;
              padding: 1rem 1.5rem !important;
              border-bottom: 4px solid #fcd800 !important;
              border-radius: 4px !important;
            }
            .cir-header-card .meta-value,
            .cir-header-card .consumer-name-header {
              color: #ffffff !important;
            }
            .cir-header-card .meta-label {
              color: #cbd5e1 !important;
            }
            .cir-badge-title {
              background-color: #fcd800 !important;
              color: #0f172a !important;
            }
            .cir-section-card {
              page-break-inside: auto !important;
              break-inside: auto !important;
              margin-bottom: 0.75rem !important;
            }
            .account-card-item {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              margin-bottom: 0.75rem !important;
            }
            .dpd-grid-table {
              border-collapse: collapse !important;
              width: 100% !important;
            }
            .dpd-pill {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .dpd-clear { background-color: #10b981 !important; color: #ffffff !important; }
            .dpd-warning-low { background-color: #f59e0b !important; color: #ffffff !important; }
            .dpd-warning-mid { background-color: #ea580c !important; color: #ffffff !important; }
            .dpd-danger { background-color: #ef4444 !important; color: #ffffff !important; }
            .dpd-neutral { background-color: #94a3b8 !important; color: #ffffff !important; }
            .score-excellent { background-color: #ecfdf5 !important; color: #059669 !important; }
            .score-good { background-color: #f0f9ff !important; color: #0284c7 !important; }
            .score-fair { background-color: #fffbeb !important; color: #d97706 !important; }
            .score-poor { background-color: #fef2f2 !important; color: #dc2626 !important; }
            .score-ntc { background-color: #f1f5f9 !important; color: #64748b !important; }
            .status-active { background-color: #dcfce7 !important; color: #15803d !important; }
            .status-closed { background-color: #f1f5f9 !important; color: #64748b !important; }
          </style>
        </head>
        <body>
          <div class="cibil-wrapper">
            <div class="cibil-report-container">
              ${printContents}
            </div>
          </div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.focus();
                window.print();
                window.close();
              }, 400);
            };
          </script>
        </body>
      </html>`);
    popupWin.document.close();
  }

  PrintDocumentsRC(divName, Header) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;

    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${Header}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>
            /* General body styles */
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
            }
  
            /* Parent div in grid layout */
            #${divName} {
              display: grid;
              grid-template-columns: repeat(4, 1fr); /* Adjust columns as needed */
              gap: 10px;
              padding: 10px;
              box-sizing: border-box;
              background-color: #d2ebec;
            }
  
            /* Styling for grid items */
            // .border-div {
            //   border: 1px solid #ddd;
            //   padding: 10px;
            //   background-color: #ffffff;
            //   text-align: left;
            //   box-sizing: border-box;
            // }
  
            /* Styling for the header */
            .printStyle {
              grid-column: span 4; /* Span across all columns */
              background-color: #28a745;
              color: white;
              text-align: center;
              font-size: 18px;
              padding: 10px;
              margin-bottom: 10px;
            }
  
            /* Headings and paragraph styles */
            h6 {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 5px;
            }
            p {
              margin: 0;
              font-size: 12px;
              font-weight: 800;
            }
  
            /* Print-specific adjustments */
            @media print {
              body {
                margin: 0;
                padding: 0;
              }
            }
          </style>
        </head>
        <body onload="window.print(); window.close()">
          <div id="${divName}">
            ${printContents}
          </div>
          <footer></footer>
        </body>
      </html>
    `);

    popupWin.document.close();
  }

  properFormat(dateStr: string): string {
    if (!dateStr) return "";
    const s = dateStr.trim();

    let d: Date;

    if (s.includes("/")) {
      const parts = s.split(" ");
      const dateParts = parts[0].split("/");
      if (dateParts.length !== 3) return s;
      if (Number(dateParts[2]) > 31) {
        d = new Date(
          Number(dateParts[2]),
          Number(dateParts[0]) - 1,
          Number(dateParts[1]),
          parts[1] ? Number(parts[1].split(":")[0]) : 0,
          parts[1] ? Number(parts[1].split(":")[1]) : 0,
        );
      } else {
        d = new Date(
          Number(dateParts[2]),
          Number(dateParts[1]) - 1,
          Number(dateParts[0]),
          parts[1] ? Number(parts[1].split(":")[0]) : 0,
          parts[1] ? Number(parts[1].split(":")[1]) : 0,
        );
      }
    } else if (s.includes("-")) {
      const parts = s.split(" ");
      const dateParts = parts[0].split("-");
      if (dateParts.length !== 3) return s;
      if (Number(dateParts[0]) > 31) {
        d = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2]),
          parts[1] ? Number(parts[1].split(":")[0]) : 0,
          parts[1] ? Number(parts[1].split(":")[1]) : 0,
        );
      } else {
        d = new Date(
          Number(dateParts[2]),
          Number(dateParts[1]) - 1,
          Number(dateParts[0]),
          parts[1] ? Number(parts[1].split(":")[0]) : 0,
          parts[1] ? Number(parts[1].split(":")[1]) : 0,
        );
      }
    } else {
      d = new Date(s);
    }

    if (isNaN(d.getTime())) return dateStr;

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  }

  getThemeColorHex(): string {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const el = document.body || document.documentElement;
      let col = getComputedStyle(el).getPropertyValue("--theme-primary").trim();
      if (!col) {
        col = getComputedStyle(document.documentElement)
          .getPropertyValue("--theme-primary")
          .trim();
      }
      if (col) {
        if (col.startsWith("#")) {
          return col;
        } else if (col.startsWith("rgb")) {
          const match = col.match(/\d+/g);
          if (match && match.length >= 3) {
            const r = parseInt(match[0], 10).toString(16).padStart(2, "0");
            const g = parseInt(match[1], 10).toString(16).padStart(2, "0");
            const b = parseInt(match[2], 10).toString(16).padStart(2, "0");
            return `#${r}${g}${b}`;
          }
        } else if (col.startsWith("hsl")) {
          const match = col.match(/[\d.]+/g);
          if (match && match.length >= 3) {
            const h = parseFloat(match[0]);
            const s = parseFloat(match[1]) / 100;
            const l = parseFloat(match[2]) / 100;
            const c = (1 - Math.abs(2 * l - 1)) * s;
            const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
            const m = l - c / 2;
            let r = 0,
              g = 0,
              b = 0;
            if (0 <= h && h < 60) {
              r = c;
              g = x;
              b = 0;
            } else if (60 <= h && h < 120) {
              r = x;
              g = c;
              b = 0;
            } else if (120 <= h && h < 180) {
              r = 0;
              g = c;
              b = x;
            } else if (180 <= h && h < 240) {
              r = 0;
              g = x;
              b = c;
            } else if (240 <= h && h < 300) {
              r = x;
              g = 0;
              b = c;
            } else if (300 <= h && h < 360) {
              r = c;
              g = 0;
              b = x;
            }
            const rHex = Math.round((r + m) * 255)
              .toString(16)
              .padStart(2, "0");
            const gHex = Math.round((g + m) * 255)
              .toString(16)
              .padStart(2, "0");
            const bHex = Math.round((b + m) * 255)
              .toString(16)
              .padStart(2, "0");
            return `#${rHex}${gHex}${bHex}`;
          }
        }
      }
    }
    return "#123c53";
  }

  getThemeColorArgb(): string {
    const hex = this.getThemeColorHex().replace("#", "").toUpperCase();
    return "FF" + (hex.length === 6 ? hex : "123C53");
  }

  exportHtmlTableToExcel(
    tableElementOrId: string | HTMLElement,
    fileName: string,
    worksheetName: string = "Sheet1",
    titleHeaderRow: string = "",
  ): void {
    let tableHtml = "";
    if (typeof tableElementOrId === "string") {
      const el = document.getElementById(tableElementOrId);
      if (el) {
        tableHtml = el.innerHTML;
      }
    } else if (
      tableElementOrId &&
      (tableElementOrId as HTMLElement).innerHTML
    ) {
      tableHtml = (tableElementOrId as HTMLElement).innerHTML;
    }

    if (!tableHtml) {
      console.warn("Table content not found for Excel export.");
      return;
    }

    const themeHex = this.getThemeColorHex();

    // Replace any CSS variable or legacy colors with theme color and force white text
    const processedHeader = titleHeaderRow
      ? titleHeaderRow
          .replace(
            /var\(--theme-primary\)/gi,
            `${themeHex}; color: #ffffff !important;`,
          )
          .replace(/#004d40/gi, themeHex)
          .replace(/#4dc3a3/gi, themeHex)
      : "";

    let processedTable = tableHtml
      .replace(
        /var\(--theme-primary\)/gi,
        `${themeHex}; color: #ffffff !important;`,
      )
      .replace(
        /background:\s*#004d40/gi,
        `background: ${themeHex}; color: #ffffff !important;`,
      )
      .replace(
        /background-color:\s*#004d40/gi,
        `background-color: ${themeHex}; color: #ffffff !important;`,
      )
      .replace(
        /background:\s*#4dc3a3/gi,
        `background: ${themeHex}; color: #ffffff !important;`,
      )
      .replace(
        /background-color:\s*#4dc3a3/gi,
        `background-color: ${themeHex}; color: #ffffff !important;`,
      );

    // Ensure all <tfoot>, total rows, and their children have explicit white text color and theme background
    processedTable = processedTable.replace(
      /<tfoot([^>]*)>([\s\S]*?)<\/tfoot>/gi,
      (match, attrs, content) => {
        const styledContent = content
          .replace(
            /<td([^>]*)>/gi,
            `<td$1 style="background-color: ${themeHex} !important; background: ${themeHex} !important; color: #ffffff !important; font-weight: bold; border: 1px solid #ffffff;">`,
          )
          .replace(
            /<th([^>]*)>/gi,
            `<th$1 style="background-color: ${themeHex} !important; background: ${themeHex} !important; color: #ffffff !important; font-weight: bold; border: 1px solid #ffffff;">`,
          )
          .replace(/<b([^>]*)>/gi, `<b$1 style="color: #ffffff !important;">`)
          .replace(
            /<strong([^>]*)>/gi,
            `<strong$1 style="color: #ffffff !important;">`,
          )
          .replace(
            /<span([^>]*)>/gi,
            `<span$1 style="color: #ffffff !important;">`,
          );
        return `<tfoot${attrs} style="background-color: ${themeHex} !important; color: #ffffff !important;">${styledContent}</tfoot>`;
      },
    );

    const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <!--[if gte mso 9]>
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>${worksheetName || "Sheet1"}</x:Name>
                <x:WorksheetOptions>
                  <x:DisplayGridlines/>
                </x:WorksheetOptions>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
        <style>
          table {
            border-collapse: collapse;
            font-family: Calibri, Arial, sans-serif;
            font-size: 11pt;
          }
          th, thead th, thead td, .header-row th, .mat-header-cell, th.mat-header-cell, .header-bg {
            background-color: ${themeHex} !important;
            background: ${themeHex} !important;
            color: #ffffff !important;
            font-weight: bold !important;
            text-align: center !important;
            vertical-align: middle !important;
            border: 1px solid #ffffff !important;
            padding: 6px 10px !important;
          }
          th *, thead * {
            color: #ffffff !important;
          }
          tfoot, tfoot td, tfoot th, .footer-row td, .total-row td, tr:last-child.footer-row td, .total-cell, .footer-bg, [class*="total"] td, [class*="footer"] td {
            background-color: ${themeHex} !important;
            background: ${themeHex} !important;
            color: #ffffff !important;
            font-weight: bold !important;
            border: 1px solid #ffffff !important;
            padding: 6px 10px !important;
          }
          tfoot *, .footer-row *, .total-row *, [class*="total"] *, [class*="footer"] *, tr:last-child td b, tr:last-child td strong, tfoot b, tfoot strong, tfoot span {
            color: #ffffff !important;
          }
          td, .mat-cell {
            border: 0.5pt solid #d1d5db;
            padding: 4px 8px;
            vertical-align: middle;
          }
        </style>
      </head>
      <body>
        <table>${processedHeader}${processedTable}</table>
      </body>
    </html>`;

    const uri = "data:application/vnd.ms-excel;base64,";
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));

    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(template);
    const finalFileName =
      fileName.endsWith(".xls") || fileName.endsWith(".xlsx")
        ? fileName
        : `${fileName}.xls`;
    downloadLink.download = finalFileName;
    downloadLink.click();
  }
}
